import React, { useEffect, useRef, useState } from 'react';

const loadScript = (url, callback) => {
  const existingScript = document.getElementById('googleMaps');
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = url;
    script.id = 'googleMaps';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    script.onload = () => {
      if (callback) callback();
    };
  } else if (callback) {
    callback();
  }
};

const AutocompleteInput = ({ value, onChange, onPlaceSelected, ...props }) => {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    loadScript(`https://maps.googleapis.com/maps/api/js?key=AIzaSyAM2A-Jw__7nmbWogxjQkiPdnqwJg4NubQ&libraries=places`, () => {
      setScriptLoaded(true);
    });
  }, []);

  useEffect(() => {
    if (scriptLoaded && window.google) {
      const qldBounds = new window.google.maps.LatLngBounds(
        { lat: -28.331298415128337, lng: 152.67148618077684 }, // Southwest corner of QLD, 
        { lat: -27.036652044524832, lng: 153.65003034609134 } // Northeast corner of QLD (brisbane)
      );

      autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, {
        types: ['address'],
        componentRestrictions: { country: 'au' },
        bounds: qldBounds,
        strictBounds: true,
      });

      autocompleteRef.current.addListener('place_changed', () => {
        const place = autocompleteRef.current.getPlace();
        onPlaceSelected(place);
      });
    }
  }, [scriptLoaded]);

  return (
    <input
      ref={inputRef}
      value={value}
      onChange={onChange}
      placeholder=''
      {...props}
    />
  );
};

export default AutocompleteInput;
